<template>
  <div class="border-left border-right border-primary py-2 border-top">
    <div
      @click="details = !details"
      class="text-primary float-left py-2 text-center cursor-pointer"
      style="width: 50px;">
      <small>{{details ? '&#9650;' : '&#9660;'}}</small>
    </div>

    <div style="margin-left: 50px;">
      <div>
        {{prescription.drug.name}}

        <small>
          {{ prescription.drug.measure }}
          {{ prescription.drug.measureUnit }}
        </small>
      </div>

      <div class="text-primary">
        {{prescription.quantity}}
        {{ declineNumber(prescription.quantity, prescription.drug.format.name) }}
      </div>

      <div
        v-show="details"
        class="py-2">
        <div class="">
          <small>{{ prescription.comment }}</small>
        </div>

        <div
          class="text-uppercase text-primary"
          v-if="prescription.startedAt !== null">

          <div v-if="durationLeft > 0">
            Осталось
            <strong>{{ durationLeft }}</strong>
            {{declineNumber(durationLeft, 'день')}}
          </div>

          <div v-else-if="durationLeft === 0">
            Последний день приема
          </div>

          <div v-else>
            Прием окончен
          </div>
        </div>

        <div>
          <small>{{ prescription.drug.description }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import calculateDaysCount from '../../../../utils/calculateDaysCount';
import declineNumber from '../../../../utils/declineNumber';
import {FORMAT_NAMES} from '../../../../constants';

export default {
  name: 'ClientDrugScheduleItem',

  props: ['prescription', 'date'],

  data() {
    return {
      details: false,
    };
  },

  computed: {
    durationLeft() {
      if (this.prescription.startedAt === null) {
        return 0;
      }

      const {startDate, finishDate, startedAt} = this.prescription;

      const daysPrescribed = calculateDaysCount(startDate, finishDate);
      const daysInProgress = calculateDaysCount(startedAt, this.date);

      return Math.ceil(daysPrescribed - daysInProgress);
    },
  },

  methods: {
    declineNumber(count, name) {
      const formatName = FORMAT_NAMES.find(item => item[0] === name);
      const [, few, one, two ] = formatName || [name, name, name, name];

      return declineNumber(count, few, one, two);
    },
  },
};
</script>
